import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { MessageCircleOff as MessageOffIcon } from "lucide-react";
import { T } from "../routes/Translate";

// Aviso cuando la otra cuenta no acepta mensajes de quien intenta escribirle
// (ajuste "Quién puede enviarte mensajes", ver utils/messaging.js). Reemplaza
// al alert() del navegador.
const MessagesClosedDialog = ({ open, onClose, name }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
    <DialogContent sx={{ textAlign: "center", pt: 3 }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          mx: "auto",
          mb: 1.5,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "action.hover",
          color: "text.secondary",
        }}
      >
        <MessageOffIcon size={28} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
        <T>No podés enviarle mensajes</T>
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {name || <T>Esta cuenta</T>}{" "}
        <T>limitó quién puede escribirle por privacidad.</T>
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button fullWidth variant="contained" onClick={onClose}>
        <T>Entendido</T>
      </Button>
    </DialogActions>
  </Dialog>
);

export default MessagesClosedDialog;
